module.exports = __webpack_public_path__ + "assets/baby.a5a865398bab413ff368bee98c190535.svg";